import { render, staticRenderFns } from "./CardAccountSetup.vue?vue&type=template&id=567c6ec8&scoped=true"
import script from "./CardAccountSetup.vue?vue&type=script&lang=ts"
export * from "./CardAccountSetup.vue?vue&type=script&lang=ts"
import style0 from "./CardAccountSetup.vue?vue&type=style&index=0&id=567c6ec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c6ec8",
  null
  
)

export default component.exports